<table class="table table-striped">
    <tr><td>Name</td><td>
        <a [routerLink]="['/task/template/show',taskTemplate.id]">
            {{taskTemplate.name}}
        </a></td></tr>
    <tr><td>Description</td><td>{{taskTemplate.description}}</td></tr>

</table>
<form  [formGroup]="searchTemplateForm" *ngIf="server_task_template_id!=0" >
  <div class="row mb-2">
            <div class="col-sm-4 text-end" > Search Solution Template to Add</div>
            <div class="col-sm-4" >
                <input   formControlName="searchInput" class="form-control"/>
            </div>
     </div>

     <div class="row">
        <div class="col-sm-4 offset-sm-4" >
         <ul>
        <li *ngFor="let template of templateList;" style="list-style: none;">
            {{template.text}}  <button (click)="addSolutionTemplate(template.id)" class="mt-1 ml-2"> Link </button>
        </li>
    </ul>
    </div>
    </div>

